var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _vm.model.lang === "zh_CN"
      ? _c("div", { staticClass: "page-total" }, [
          _vm._v(
            _vm._s(
              _vm.KDApi.getLangMsg(_vm.model, "tips.total") +
                _vm.totalPage +
                _vm.KDApi.getLangMsg(_vm.model, "tips.pages")
            )
          )
        ])
      : _c("div", { staticClass: "page-total" }, [
          _vm._v(
            _vm._s(
              _vm.KDApi.getLangMsg(_vm.model, "tips.total") +
                " " +
                _vm.totalPage +
                " " +
                _vm.KDApi.getLangMsg(_vm.model, "tips.pages")
            )
          )
        ]),
    _vm._v(" "),
    _vm.model.lang === "zh_CN"
      ? _c("div", { staticClass: "page-num" }, [
          _vm._v(_vm._s(_vm.KDApi.getLangMsg(_vm.model, "tips.pageno"))),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currPage,
                expression: "currPage"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.currPage },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currPage = $event.target.value
              }
            }
          }),
          _vm._v(_vm._s(_vm.KDApi.getLangMsg(_vm.model, "tips.page")))
        ])
      : _c("div", { staticClass: "page-num" }, [
          _vm._v(_vm._s(_vm.KDApi.getLangMsg(_vm.model, "tips.pageno"))),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.currPage,
                expression: "currPage"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.currPage },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currPage = $event.target.value
              }
            }
          })
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "op-page" }, [
      _c("span", { staticClass: "first-page" }, [
        _c("i", {
          staticClass: "kdicon kdicon-first",
          class: { dis: _vm.currPage == 1 },
          on: {
            click: function($event) {
              _vm.currPage = 1
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "next-page" }, [
        _c("i", {
          staticClass: "kdicon kdicon-arrow-left",
          class: { dis: _vm.currPage == 1 },
          on: {
            click: function($event) {
              _vm.currPage -= 1
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "pre-page" }, [
        _c("i", {
          staticClass: "kdicon kdicon-arrow-right",
          class: { dis: _vm.currPage == _vm.totalPage },
          on: {
            click: function($event) {
              _vm.currPage += 1
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "last-page" }, [
        _c("i", {
          staticClass: "kdicon kdicon-last",
          class: { dis: _vm.currPage == _vm.totalPage },
          on: {
            click: function($event) {
              _vm.currPage = _vm.totalPage
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { ref: "rangeDOm", staticClass: "page-range" }, [
      _vm.model.lang === "zh_CN"
        ? _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.showRangeList = !_vm.showRangeList
                }
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.range +
                    _vm.KDApi.getLangMsg(_vm.model, "tips.items") +
                    "/" +
                    _vm.KDApi.getLangMsg(_vm.model, "tips.page")
                )
              )
            ]
          )
        : _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.showRangeList = !_vm.showRangeList
                }
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.range +
                    " " +
                    _vm.KDApi.getLangMsg(_vm.model, "tips.items") +
                    "/" +
                    _vm.KDApi.getLangMsg(_vm.model, "tips.page")
                )
              )
            ]
          ),
      _vm._v(" "),
      _c("span", { staticClass: "select" }, [
        _c("i", {
          staticClass: "kdicon kdicon-arrow-down",
          class: { active: _vm.showRangeList },
          on: {
            click: function($event) {
              _vm.showRangeList = !_vm.showRangeList
            }
          }
        }),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showRangeList,
                expression: "showRangeList"
              }
            ],
            staticClass: "page-range_list"
          },
          _vm._l(_vm.rangeList, function(i) {
            return _c(
              "li",
              {
                key: "range" + i,
                staticClass: "page-range_item",
                class: { act: i == _vm.range },
                on: {
                  click: function($event) {
                    _vm.range = i
                    _vm.showRangeList = false
                  }
                }
              },
              [
                _vm.model.lang === "zh_CN"
                  ? _c("span", { staticClass: "item_zh" }, [
                      _vm._v(
                        _vm._s(
                          i +
                            _vm.KDApi.getLangMsg(_vm.model, "tips.items") +
                            "/" +
                            _vm.KDApi.getLangMsg(_vm.model, "tips.page")
                        )
                      )
                    ])
                  : _c("span", { staticClass: "item_us" }, [
                      _vm._v(
                        _vm._s(
                          i +
                            " " +
                            _vm.KDApi.getLangMsg(_vm.model, "tips.items") +
                            "/" +
                            _vm.KDApi.getLangMsg(_vm.model, "tips.page")
                        )
                      )
                    ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }